
import { useState, useCallback } from 'react';

interface AddressCache {
  [key: string]: string;
}

export const useAddressCache = () => {
  const [cache, setCache] = useState<AddressCache>({});
  const [loadingAddresses, setLoadingAddresses] = useState<Set<string>>(new Set());

  const getCacheKey = (lat: number, lng: number) => `${lat.toFixed(5)},${lng.toFixed(5)}`;

  const getAddress = useCallback((lat: number, lng: number) => {
    const key = getCacheKey(lat, lng);
    return cache[key];
  }, [cache]);

  const setAddress = useCallback((lat: number, lng: number, address: string) => {
    const key = getCacheKey(lat, lng);
    setCache(prev => ({ ...prev, [key]: address }));
  }, []);

  const isLoading = useCallback((lat: number, lng: number) => {
    const key = getCacheKey(lat, lng);
    return loadingAddresses.has(key);
  }, [loadingAddresses]);

  const setLoading = useCallback((lat: number, lng: number, loading: boolean) => {
    const key = getCacheKey(lat, lng);
    setLoadingAddresses(prev => {
      const newSet = new Set(prev);
      if (loading) {
        newSet.add(key);
      } else {
        newSet.delete(key);
      }
      return newSet;
    });
  }, []);

  return {
    getAddress,
    setAddress,
    isLoading,
    setLoading
  };
};
